import { render } from "./PostalCodeBrowseItem.vue?vue&type=template&id=3cddc262"
import script from "./PostalCodeBrowseItem.vue?vue&type=script&lang=js"
export * from "./PostalCodeBrowseItem.vue?vue&type=script&lang=js"
script.render = render

export default script